import { Entity } from '@debbie/common/dist';
import { h } from '@debbie/cortex/dist';
import { xml } from '@debbie/common/dist/util/formats';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Loading from '../Loading';
import Email from '../Email';
import { InteractionType, } from '@debbie/common/dist/interactions';
import Panel from '../Panel';
import THEME from '../../theme';
import { EmailInteraction } from '../interactions';
import { sortBy } from '@debbie/common/dist/util';
import Timestamp from '../Timestamp';
import moment from 'moment';
import { CornerUpLeft, X } from '../Icons';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions';
const EmailThread = (props) => {
    var _a;
    const interactions = useInteractionsByReference(Entity.Case, props.caseId, true);
    const lang = useSelector((s) => s.lang);
    const [replyingTo, setReplyingTo] = useState(null);
    if (!h.hasData(interactions) || interactions.data == null) {
        return React.createElement(Loading, null);
    }
    const emails = sortBy(interactions.data.filter((inter) => inter.type === InteractionType.Email), (inter) => new Date(inter.createdAt).getTime());
    const mainEmail = emails.find((inter) => inter.id === props.referenceInteraction);
    if (mainEmail == null) {
        return React.createElement("div", null, "No email referenced");
    }
    const relevantEmails = findRelevantEmails(emails, mainEmail);
    let items = [];
    for (const email of relevantEmails) {
        const refs = extractIds((_a = email.details.references) !== null && _a !== void 0 ? _a : '');
        refs.reverse();
        let count = 0;
        for (const ref of refs) {
            if (items.find((item) => {
                var _a;
                return typeof item === 'object' &&
                    ((_a = item.details.imapId) !== null && _a !== void 0 ? _a : '').trim() === ref;
            })) {
                break;
            }
            console.log(refs, emails.map((x) => x.details.imapId));
            count += 1;
        }
        if (count > 0) {
            // Uncomment to enable missing emails shown in UI
            // items.push(count)
        }
        items.push(email);
    }
    items.reverse();
    return (React.createElement(Wrapper, null, items.map((email) => {
        var _a;
        if (typeof email === 'number') {
            return (React.createElement(Panel, null,
                "Kunne ikke finde ",
                email,
                " ",
                email === 1 ? 'email' : 'emails'));
        }
        const isReference = email.id === props.referenceInteraction;
        const beingRepliedTo = replyingTo === email.id;
        return (React.createElement(React.Fragment, null,
            beingRepliedTo && (React.createElement(Panel, { header: React.createElement(Header, null,
                    React.createElement("span", null, lang.interactions.reply),
                    React.createElement(Close, { onClick: () => {
                            setReplyingTo(null);
                        } })) },
                React.createElement(EmailInteraction, { referenceId: email.referenceId, referenceType: Entity.Case, emailTo: email.details.from, emailToEditable: true, inReplyTo: (_a = email.details.imapId) !== null && _a !== void 0 ? _a : undefined, defaultSubject: `Re: ${email.details.subject}`, 
                    /* defaultContent={`<br/><br/>${createLine(email)}<br/>${
                      email.details.html
                        ? extractBody(email.details.html)
                        : `${email.details.body}`
                    }`} */
                    references: (email.details.references
                        ? `${email.details.references} `
                        : '') + `${email.details.imapId}`, onSent: () => {
                        setReplyingTo(null);
                    } }))),
            React.createElement(HighLightPanel, { isReference: isReference, header: React.createElement(Header, null,
                    React.createElement("span", null,
                        lang.interactions[email.direction],
                        " -",
                        ' ',
                        React.createElement(Timestamp, { date: email.createdAt })),
                    React.createElement(Reply, { onClick: () => {
                            setReplyingTo(email.id);
                        }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.interactions.reply })) },
                React.createElement(EmailComp, { interaction: email }))));
    })));
};
const createLine = (email) => {
    return xml `Fra ${email.details.from} (${moment(email.createdAt).format('DD/MM/YYYY HH:mm')}):`;
};
const extractBody = (str) => {
    if (str.includes('<body>') && str.includes('</body>')) {
        return str.split('<body>')[1].split('</body>')[0];
    }
    return str;
};
const extractIds = (str) => {
    const messageIdPattern = /<[^>]+@[^>]+>|[^\s@<>]+@[^>\s]+/g;
    const matches = str.match(messageIdPattern);
    return matches ? matches : [];
};
const findRelevantEmails = (emails, email) => {
    const imapId = email.details.imapId;
    if (imapId == null || imapId === '') {
        return [email];
    }
    const lookup = {};
    const findChild = (container, childRef) => {
        if (container.children.length != 0) {
            return false;
        }
        for (const child of container.children) {
            if (lookup[childRef] === child) {
                return true;
            }
            if (findChild(child, childRef)) {
                return true;
            }
        }
        return false;
    };
    const safeToMerge = (ref1, ref2) => {
        if (lookup[ref1] && findChild(lookup[ref1], ref2)) {
            return false;
        }
        if (lookup[ref2] && findChild(lookup[ref2], ref1)) {
            return false;
        }
        return true;
    };
    for (const email of emails) {
        if (email.details.imapId) {
            if (lookup[email.details.imapId]) {
                lookup[email.details.imapId].message = {
                    references: email.details.references
                        ? extractIds(email.details.references)
                        : [],
                    inReplyTo: email.details.inReplyTo
                        ? extractIds(email.details.inReplyTo).length > 0
                            ? extractIds(email.details.inReplyTo)[0]
                            : null
                        : null,
                    interactionId: email.id,
                };
            }
            else {
                lookup[email.details.imapId] = {
                    message: {
                        references: email.details.references
                            ? extractIds(email.details.references)
                            : [],
                        inReplyTo: email.details.inReplyTo
                            ? extractIds(email.details.inReplyTo).length > 0
                                ? extractIds(email.details.inReplyTo)[0]
                                : null
                            : null,
                        interactionId: email.id,
                    },
                    parent: null,
                    children: [],
                };
            }
            const refs = lookup[email.details.imapId].message.references;
            for (let i = 0; i < refs.length; i++) {
                const ref = refs[i];
                if (lookup[ref] == null) {
                    lookup[ref] = { parent: null, children: [], message: null };
                }
                if (refs[i - 1] != null &&
                    safeToMerge(refs[i - 1], ref) &&
                    lookup[ref].parent == null) {
                    lookup[ref].parent = lookup[refs[i - 1]];
                    lookup[refs[i - 1]].children.push(lookup[ref]);
                }
            }
            if (refs.length > 0) {
                lookup[email.details.imapId].parent = lookup[refs[refs.length - 1]];
                if (!lookup[email.details.imapId].parent.children.includes(lookup[email.details.imapId])) {
                    lookup[email.details.imapId].parent.children.push(lookup[email.details.imapId]);
                }
            }
        }
    }
    // Check: https://www.jwz.org/doc/threading.html
    let relevantEmails = [];
    const addRoot = (email) => {
        if (email.parent != null) {
            addRoot(email.parent);
        }
        if (email.message) {
            const interaction = emails.find((inter) => inter.id === email.message.interactionId);
            if (interaction) {
                relevantEmails.push(interaction);
            }
        }
    };
    addRoot(lookup[imapId]);
    const addChildren = (email) => {
        // TODO: Sort?
        for (const child of email.children) {
            if (child.message) {
                const interaction = emails.find((inter) => inter.id === child.message.interactionId);
                if (interaction) {
                    relevantEmails.push(interaction);
                }
            }
        }
        for (const child of email.children) {
            addChildren(child);
        }
    };
    addChildren(lookup[imapId]);
    return relevantEmails;
};
const Wrapper = styled.div `
  background: ${THEME.BACKGROUND};
  padding: 1em;
`;
const EmailComp = styled(Email) `
  margin-bottom: 1em;
`;
const HighLightPanel = styled(Panel) `
  border-bottom: ${(props) => props.isReference ? '5px solid rgba(32, 13, 84, 0.6)' : 'none'};
`;
const ThreadButtons = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Reply = styled(CornerUpLeft) `
  border-radius: 10000px;
  padding: 0.5em;
  width: 2em;
  height: 2em;
  background: white;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;
const Close = styled(X) `
  border-radius: 10000px;
  padding: 0.5em;
  width: 2em;
  height: 2em;
  background: white;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;
export default EmailThread;
//# sourceMappingURL=EmailThread.js.map